import { latestMemory, memoryAnchor } from '@/lib/memory';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useChatInteract, useChatMessages } from '@chainlit/react-client';

/** The newest memory count of this chat and where its line goes. */
export function useConversationMemory() {
  const { messages } = useChatMessages();
  return useMemo(() => {
    const latest = latestMemory(messages);
    const firstQuestion = latest?.flat.find((s) => s.type === 'user_message');
    return {
      state: latest?.state,
      anchorId: memoryAnchor(latest),
      // Stable for the life of a chat, reopened or not: what "once per chat"
      // is keyed on.
      chatKey: firstQuestion?.id
    };
  }, [messages]);
}

/**
 * The same New Chat the header offers, without its confirm dialog: here the
 * user has just read why a new chat helps and pressed a button that says so.
 * Cheap on purpose -- the container keeps its tables and only the
 * conversation is reset (signals-copilot /new_conversation).
 */
export function useStartNewChat() {
  const { clear } = useChatInteract();
  const navigate = useNavigate();
  return useCallback(() => {
    clear();
    navigate('/');
  }, [clear, navigate]);
}
